import { Component, computed, inject, input } from '@angular/core';
import { SuperSectionVM } from '../../../../models/menu.model';
import { MenuService } from '../../../menu.service';

@Component({
  selector: 'app-super-section-list',
  templateUrl: './super-section-list.component.html',
  styleUrl: './super-section-list.component.scss',
  standalone: false,
})

export class SuperSectionListComponent {
  private menuService = inject(MenuService);

  sections = input<SuperSectionVM[] | undefined>(undefined);
  superSections = computed(() => this.sections() ?? this.menuService.superSections());
}